module.exports = __webpack_public_path__ + "media/images/pdf/logo_sumai-85cbb7ca4837dde7f19abc059d04713f.png";